module.exports = __webpack_public_path__ + "media/icons/naped-tyl-active-6d53e35c.png";